import React, { useEffect, useState, ReactElement, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  auth,
  verifyPasswordResetCode,
  confirmPasswordReset,
  getAuthInstance,
  signInWithEmail,
  applyActionCode,
} from "../../apis/firebase";

import { useFormik } from "formik";
import * as Yup from "yup";
import { AuthContext } from "../../context/auth.context";

import { useTranslation } from "react-i18next";

const ResetPassword = (): ReactElement => {
  const [params, setParams] = useState<any>("");
  const [recoveringEmail, setRecoveringEmail] = useState("");
  const [isSubmittedSuccessfully, setIsSubmittedSuccessfully] = useState(false);
  const { setUserInfo, userInfo } = useContext(AuthContext);
  const { t } = useTranslation();
  const [isEmailVerificationSuccess, setIsEmailVerificationSuccess] =
    useState(false);

  const history = useHistory();

  const [hidePassword, setHidePassword] = useState(true);
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    (async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (!!params && !!params.oobCode) {
        if (params.mode === "resetPassword") {
          try {
            const email = await verifyPasswordResetCode(auth, params.oobCode);
            setRecoveringEmail(email);
          } catch (e) {
            alert("Link is expired");
            throw e.code;
          }
        } else if (params.mode === "verifyEmail") {
          try {
            handleVerifyEmail(auth, params.oobCode);
          } catch (e) {
            alert("Link is expired");
            throw e.code;
          }
        }
        setParams(params);
      } else {
        history.push("/404");
      }
    })();
  }, []);

  const handleVerifyEmail = (auth, actionCode) => {
    applyActionCode(auth, actionCode)
      .then((resp) => {
        setIsEmailVerificationSuccess(true);
        setUserInfo({ ...userInfo });
        setTimeout(() => {
          // history.push("/");
          window.location.href = "/";
        }, 5000);
      })
      .catch((e) => {
        alert(e.message);
        throw e.code;
      });
  };

  const initialValues = {
    email: "",
    password: "",
    confirm_password: "",
  };
  const FormSchema = Yup.object().shape({
    password: Yup.string().required(t("FORM_PASSWORD_VALIDATION_REQUIRED")),
    // confirm_password: Yup.string().oneOf(
    //   [Yup.ref("password"), null],
    //   "Passwords must match"
    // ),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: FormSchema,
    onSubmit: async (values) => {
      try {
        const authInstance = getAuthInstance();

        await confirmPasswordReset(
          authInstance,
          params.oobCode,
          values.password
        );

        setIsSubmittedSuccessfully(true);

        setTimeout(async () => {
          await signInWithEmail(recoveringEmail, values.password);
        }, 3000);
      } catch (e) {
        // alert(e.code);
        setLoginError(` ${e.message}`);
      }
    },
  });

  return (
    <>
      {params.mode === "resetPassword" && (
        <div className="d-flex flex-column mb-4">
          <div className="mb-3">
            <div className="d-flex align-items-start justify-content-between">
              <h1 className="mb-2">
                {!isSubmittedSuccessfully
                  ? t("RESET_PASSWORD_TITLE")
                  : t("RESET_PASSWORD_SUCCESS_TITLE")}
              </h1>
            </div>

            {isSubmittedSuccessfully && (
              <p className="m-0">{t("RESET_PASSWORD_SUCCESS_DESCRIPTION")}</p>
            )}
          </div>
          {!isSubmittedSuccessfully && (
            <div>
              <form onSubmit={formik.handleSubmit}>
                <span className="danger">{loginError}</span>
                <div className="mb-3">
                  <div className="input-group ">
                    <input
                      type={hidePassword ? "password" : "text"}
                      placeholder={t("FORM_PASSWORD_PLACEHOLDER")}
                      className={`form-control ${
                        formik.errors.password ? "is-invalid" : ""
                      }`}
                      name="password"
                      {...formik.getFieldProps("password")}
                    />
                    <div className="input-group-text">
                      <button
                        type="button"
                        className="bi bi-eye-fill"
                        onClick={() => {
                          setHidePassword(!hidePassword);
                        }}
                      />
                    </div>
                    {formik.touched.password && formik.errors.password ? (
                      <div className="invalid-feedback error-block">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>
                  <p className="m-0 mt-2">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: t("RESET_PASSWORD_DESCRIPTION"),
                      }}
                    />
                  </p>
                </div>

                <button type="submit" className="btn btn-primary fw-bold w-100">
                  {t("FORM_BUTTON_SUBMIT_LABEL")}
                </button>
              </form>
            </div>
          )}
        </div>
      )}

      {params.mode === "verifyEmail" && (
        <div className="d-flex flex-column mb-4">
          <div className="mb-3">
            <h1 className="mb-2">{t("VERIFY_EMAIL_SUCCESS_TITLE")}</h1>
            <p className="m-0">
              {isEmailVerificationSuccess
                ? t("VERIFY_EMAIL_SUCCESS_DESCRIPTION")
                : t("VERIFY_EMAIL_ERROR_DESCRIPTION")}
              {/* <Link to="/">  </Link> */}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPassword;
